<template>
  <ul :class="b('')">
    <li
      v-for="index in pages"
      :key="index"
      :class="b('item', { active: index === activePage + 1 })"
      @click="$emit('select', index - 1)"
    ></li>
  </ul>
</template>

<script>
  /**
   * Renders a regular slider pagination.
   */
  export default {
    name: 'c-slide-pagination',

    // components: { },
    // mixins: [],

    props: {
      /**
       * Set the number of pages.
       */
      pages: {
        type: Number,
        required: true,
      },

      /**
       * Set the active page index.
       */
      activePage: {
        type: Number,
        required: true,
      },
    },

    emits: ['select'],

    // data() { return { }; },
    // computed: { },
    // watch: { },
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() { },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() { },
    // unmounted() {},
    // methods: { },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  // @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-slide-pagination {
    $this: &;

    @extend %list-reset;

    display: flex;
    justify-content: center;

    &__item {
      position: relative;
      display: block;
      width: functions.rem(30px);
      margin-left: functions.rem(4px);
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &::before {
        content: '';
        float: left;
        width: 0;
        height: 0;
        padding-top: 100%;
      }

      &::after {
        position: absolute;
        top: calc(50% - 1px);
        right: 0;
        left: 0;
        content: '';
        height: 0;
        border-bottom: 1px solid functions.get-theme-var('c-slide-pagination-item-color');
        transition: border-color variables.$transition-duration--200;
      }

      body:not(.uses-touch) &:hover::after,
      &--active::after {
        border-color: functions.get-theme-var('c-slide-pagination-item-color--active');
      }
    }
  }
</style>
